export const eventCardData = [
  {
    status: "500 ERR",
    request: "POST /dashboard/v1/in_7046_3138/invalid",
    date: "15/07/2021",
  },
  {
    status: "200 OK",
    request: "GET /dashboard/v1/in_7046_3138/payment",
    date: "18/01/2021",
  },
  {
    status: "404 NOT",
    request: "PUT /dashboard/v1/in_7046_3138/place",
    date: "25/01/2021",
  },
  {
    status: "500 ERR",
    request: "POST /dashboard/v1/in_7046_3138/invalid",
    date: "02/11/2020",
  },
  {
    status: "200 OK",
    request: "GET /dashboard/v1/in_7046_3138/payment",
    date: "25/09/2021",
  },
  {
    status: "404 NOT",
    request: "PUT /dashboard/v1/in_7046_3138/place",
    date: "08/11/2020",
  },
  {
    status: "500 ERR",
    request: "DELETE /dashboard/v1/in_7046_3138/invalid",
    date: "15/05/2021",
  },
  {
    status: "200 OK",
    request: "UPDATE /dashboard/v1/in_7046_3138/payment",
    date: "28/12/2020",
  },
  {
    status: "404 NOT",
    request: "POST /dashboard/v1/in_7046_3138/place",
    date: "31/03/2021",
  },
  {
    status: "500 ERR",
    request: "GET /dashboard/v1/in_7046_3138/invalid",
    date: "21/12/2020",
  },
];
